var map = {
	"./Kentico.svg": 92472,
	"./Kontent.svg": 86090,
	"./Strapi.svg": 10200,
	"./about-skating-butler.svg": 14568,
	"./amazon.svg": 93677,
	"./atom.svg": 78935,
	"./backgrounds/background-line-arrow-head.svg": 72433,
	"./backgrounds/background-line.svg": 57601,
	"./backgrounds/cloud-dots-bottom.svg": 53288,
	"./backgrounds/cloud-dots-top.svg": 45994,
	"./backgrounds/cloud-page_header-dots-a.svg": 74274,
	"./backgrounds/cloud-page_header-dots-b.svg": 10365,
	"./backgrounds/cloud-page_proof-arrow.svg": 95908,
	"./backgrounds/cloud-page_proof-watermark.svg": 51297,
	"./backgrounds/concierge-form-bg-left-bottom.svg": 79990,
	"./backgrounds/concierge-form-bg-left-center.svg": 36498,
	"./backgrounds/concierge-form-bg-right-center.svg": 41255,
	"./backgrounds/concierge-page_header-a.svg": 9664,
	"./backgrounds/concierge-page_header-b.svg": 36254,
	"./backgrounds/concierge-page_header-c.svg": 86293,
	"./backgrounds/cta-block-hands-a.svg": 429,
	"./backgrounds/cta-block-hands-b.svg": 51086,
	"./backgrounds/cta-block-hands-c.svg": 48634,
	"./backgrounds/home_dots.svg": 28627,
	"./ball-being-rolled.svg": 78460,
	"./bg-home.svg": 58769,
	"./checkmark.svg": 40821,
	"./color-blocks.svg": 1050,
	"./concierge-account-management.svg": 94759,
	"./concierge-audit.svg": 70084,
	"./concierge-review.svg": 1235,
	"./concierge-slack-channel.svg": 79935,
	"./concierge-ticket-prioritization.svg": 33022,
	"./concierge-training.svg": 63366,
	"./contentful.svg": 18553,
	"./contentstack.svg": 21901,
	"./datocms.svg": 28231,
	"./diagram/cdn-mini.svg": 57406,
	"./diagram/cdn-new.svg": 39493,
	"./diagram/cdn.svg": 82603,
	"./diagram/cli-big.svg": 90574,
	"./diagram/cli-mini.svg": 9379,
	"./diagram/cms-big.svg": 64070,
	"./diagram/cms-documents.svg": 35173,
	"./diagram/cms-mini.svg": 54420,
	"./diagram/cms.svg": 85639,
	"./diagram/code-documents.svg": 78741,
	"./diagram/content-creator.svg": 76653,
	"./diagram/database.svg": 40628,
	"./diagram/developer.svg": 3888,
	"./diagram/filesystem.svg": 24405,
	"./diagram/react.svg": 61436,
	"./diagram/user-new-small.svg": 87715,
	"./diagram/user-new.svg": 55233,
	"./diagram/user.svg": 94162,
	"./docs-keyvisual-conceptual-guides.svg": 80766,
	"./docs-keyvisual-homepage.svg": 55753,
	"./docs-keyvisual-how-to-guides.svg": 57690,
	"./docs-keyvisual-reference-guides.svg": 51965,
	"./docs-keyvisual-tutorials.svg": 7717,
	"./drupal.svg": 92162,
	"./gatsby-days-logo.svg": 6064,
	"./guides-astronaut-butler.svg": 46040,
	"./guides-markdown.svg": 24174,
	"./guides-react-hero-bottom.svg": 58969,
	"./guides-react.svg": 95892,
	"./guides-stars.svg": 5376,
	"./hand-dropping-ball.svg": 87561,
	"./hosting.svg": 94191,
	"./icon-apps.svg": 74178,
	"./icon-data.svg": 35350,
	"./icon-deployment.svg": 99517,
	"./icon-link.svg": 58440,
	"./icon-performance.svg": 96898,
	"./icons/article.svg": 99591,
	"./icons/gatsby-4-icon.svg": 67684,
	"./icons/md-arrow-forward.svg": 53102,
	"./jekyll.svg": 69960,
	"./light-purple-dot.svg": 73477,
	"./logo.svg": 58636,
	"./markdown.svg": 37242,
	"./monogram.svg": 69780,
	"./netlify-grayscale.svg": 231,
	"./netlify.svg": 38072,
	"./nextjs.svg": 38491,
	"./ornaments/pricing-page-cta-stars.svg": 69907,
	"./ornaments/pricing-page-header-underline.svg": 90669,
	"./pictures/cloud-page_cms-previews-desktop.svg": 5570,
	"./pictures/cloud-page_cms-previews-mobile.svg": 41538,
	"./pictures/cloud-page_deploy-previews-desktop.svg": 47256,
	"./pictures/cloud-page_deploy-previews-mobile.svg": 89943,
	"./pictures/cloud-page_incremental-builds-desktop.svg": 36099,
	"./pictures/cloud-page_incremental-builds-mobile.svg": 22303,
	"./pictures/cloud-page_lighthouse-reports-desktop.svg": 21229,
	"./pictures/cloud-page_lighthouse-reports-mobile.svg": 89642,
	"./pictures/pricing-page-cta.svg": 38699,
	"./pictures/pricing-page_concierge.svg": 67584,
	"./pwa.svg": 44463,
	"./pwa_card.svg": 55605,
	"./react.svg": 62256,
	"./sanitize.svg": 31463,
	"./sanity.svg": 78790,
	"./silly-site-award.svg": 19340,
	"./silly-site-background.svg": 69211,
	"./silly-site-challenge-pattern-light.svg": 44661,
	"./silly-site-challenge-pattern.svg": 18413,
	"./silly-site-shapes.svg": 14023,
	"./silly-site-swag.svg": 83821,
	"./source.svg": 27550,
	"./support-cloud-knowledge-base.svg": 43660,
	"./support-form-background.svg": 8655,
	"./support-form-hand.svg": 61242,
	"./support-open-source-docs.svg": 69048,
	"./support-product-roadmap.svg": 17709,
	"./support-status-page.svg": 72697,
	"./use-case-ellipse-2.svg": 60899,
	"./use-case-ellipse.svg": 80192,
	"./use-case-polygon.svg": 97319,
	"./use-case-rectangle.svg": 87813,
	"./wordpress.svg": 19981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36600;